<!-- 主要個人資料編輯模態框 -->
<div class="modal-backdrop" (click)="onClose()"></div>
<div class="modal-dialog user-profile-modal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <i class="fas fa-user-edit"></i>
        {{ 'user_profile.title' | translate }}
      </h3>
      <button type="button" class="close-btn" (click)="onClose()">&times;</button>
    </div>
    
    <div class="modal-body">
      <!-- 成功訊息 -->
      <div *ngIf="successMessage" class="alert alert-success">
        <i class="fas fa-check-circle"></i>
        {{ successMessage }}
      </div>

      <!-- 錯誤訊息 -->
      <div *ngIf="errorMessage" class="alert alert-danger">
        <i class="fas fa-exclamation-triangle"></i>
        {{ errorMessage }}
      </div>

      <form #profileForm="ngForm">
        <!-- 基本資料區塊 -->
        <div class="form-section">
          <h4 class="section-title">
            <i class="fas fa-user"></i>
            {{ 'user_profile.basic_info' | translate }}
          </h4>

          <!-- 帳號 (唯讀) -->
          <div class="form-group">
            <label for="username">{{ 'user_profile.username' | translate }}</label>
            <input 
              type="text" 
              id="username" 
              name="username" 
              [(ngModel)]="userProfileData.username"
              class="form-control" 
              readonly
              [placeholder]="'user_profile.username_readonly' | translate">
          </div>

          <!-- 姓名 -->
          <div class="form-group">
            <label for="fullName">{{ 'user_profile.full_name' | translate }}</label>
            <input 
              type="text" 
              id="fullName" 
              name="fullName" 
              [(ngModel)]="userProfileData.fullName"
              class="form-control" 
              [placeholder]="'user_profile.full_name_placeholder' | translate">
          </div>

          <!-- 電子郵件 -->
          <div class="form-group">
            <label for="email">{{ 'user_profile.email' | translate }}</label>
            <input 
              type="email" 
              id="email" 
              name="email" 
              [(ngModel)]="userProfileData.email"
              class="form-control" 
              [placeholder]="'user_profile.email_placeholder' | translate">
          </div>

          <!-- 職位 -->
          <div class="form-group">
            <label for="position">{{ 'user_profile.position' | translate }}</label>
            <input 
              type="text" 
              id="position" 
              name="position" 
              [(ngModel)]="userProfileData.position"
              class="form-control" 
              [placeholder]="'user_profile.position_placeholder' | translate">
          </div>
        </div>

        <!-- 密碼變更區塊 -->
        <div class="form-section">
          <h4 class="section-title">
            <i class="fas fa-lock"></i>
            {{ 'user_profile.password_section' | translate }}
          </h4>
          
          <div class="password-change-section">
            <p class="section-description">
              {{ 'user_profile.password_change_description' | translate }}
            </p>
            <button 
              type="button" 
              class="btn btn-warning change-password-btn"
              (click)="openPasswordChangeModal()">
              <i class="fas fa-key"></i>
              {{ 'user_profile.change_password' | translate }}
            </button>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="saveProfile()"
        [disabled]="isSubmitting">
        <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
        <i class="fas fa-save me-2"></i>
        {{ 'user_profile.save_changes' | translate }}
      </button>
      <button 
        type="button" 
        class="btn btn-secondary" 
        (click)="onClose()">
        <i class="fas fa-times me-2"></i>
        {{ 'user_profile.cancel' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- 密碼變更子模態框 -->
<div *ngIf="showPasswordChangeModal" class="modal-backdrop password-modal-backdrop" (click)="closePasswordChangeModal()"></div>
<div *ngIf="showPasswordChangeModal" class="modal-dialog password-change-modal">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h4>
        <i class="fas fa-key"></i>
        {{ 'user_profile.password_change.title' | translate }}
      </h4>
      <button type="button" class="close-btn" (click)="closePasswordChangeModal()">&times;</button>
    </div>
    
    <div class="modal-body">
      <!-- 密碼變更說明 -->
      <div class="password-change-info">
        <div class="info-box">
          <i class="fas fa-info-circle"></i>
          <p>{{ 'user_profile.password_change.instructions' | translate }}</p>
        </div>
      </div>

      <!-- 錯誤訊息 (密碼變更專用) -->
      <div *ngIf="errorMessage" class="alert alert-danger">
        <i class="fas fa-exclamation-triangle"></i>
        {{ errorMessage }}
      </div>

      <form #passwordForm="ngForm">
        <!-- 現有密碼 -->
        <div class="form-group">
          <label for="currentPassword">{{ 'user_profile.password_change.current_password' | translate }} *</label>
          <input 
            type="password" 
            id="currentPassword" 
            name="currentPassword" 
            [(ngModel)]="passwordChangeData.currentPassword"
            class="form-control" 
            required
            [placeholder]="'user_profile.password_change.current_password_placeholder' | translate">
        </div>

        <!-- 新密碼 -->
        <div class="form-group">
          <label for="newPassword">{{ 'user_profile.password_change.new_password' | translate }} *</label>
          <input 
            type="password" 
            id="newPassword" 
            name="newPassword" 
            [(ngModel)]="passwordChangeData.newPassword"
            class="form-control" 
            required
            minlength="6"
            [placeholder]="'user_profile.password_change.new_password_placeholder' | translate">
          <small class="form-text text-muted">
            {{ 'user_profile.password_change.password_requirements' | translate }}
          </small>
        </div>

        <!-- 確認新密碼 -->
        <div class="form-group">
          <label for="confirmPassword">{{ 'user_profile.password_change.confirm_password' | translate }} *</label>
          <input 
            type="password" 
            id="confirmPassword" 
            name="confirmPassword" 
            [(ngModel)]="passwordChangeData.confirmPassword"
            class="form-control" 
            required
            [placeholder]="'user_profile.password_change.confirm_password_placeholder' | translate">
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button 
        type="button" 
        class="btn btn-primary" 
        (click)="changePassword()"
        [disabled]="isPasswordChanging || !passwordChangeData.currentPassword || !passwordChangeData.newPassword || !passwordChangeData.confirmPassword">
        <span *ngIf="isPasswordChanging" class="spinner-border spinner-border-sm me-2"></span>
        <i class="fas fa-key me-2"></i>
        {{ 'user_profile.password_change.confirm_change' | translate }}
      </button>
      <button 
        type="button" 
        class="btn btn-secondary" 
        (click)="closePasswordChangeModal()">
        <i class="fas fa-times me-2"></i>
        {{ 'user_profile.password_change.cancel' | translate }}
      </button>
    </div>
  </div>
</div>